import { render } from "./FilterSummary.vue?vue&type=template&id=5fa585dc"
const script = {}

import "./FilterSummary.vue?vue&type=style&index=0&id=5fa585dc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__